export function getUserAvatarText(user) {
  if (user.userImageUrl) return '';

  if (user.isEmailOnlyUser) return '@';

  let userFullName = user.firstName + ' ' + user.lastName;

  // if name contains more than 2 words, return only 2 words (one first word and one last word)
  let words = userFullName.trim().split(' ');
  if (words.length > 2) return words[0] + ' ' + words[words.length - 1];

  return userFullName;
}
